<div
  [ngStyle]="{
    'grid-template-columns': selectedView.style.gridTemplateColumns,
    'grid-template-rows': selectedView.style.gridTemplateRows
  }"
>
  <ng-content></ng-content>
</div>
